var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "container media-gallery-navigation" }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-12 media-gallery-navigation__list" },
        [
          _c(
            "router-link",
            {
              staticClass: "media-gallery-navigation__item headline-2",
              attrs: {
                "active-class": "navigation-active",
                to: { name: _vm.ROUTES.SEARCH },
              },
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("mediaGallery.navigation.mediaSearch.label")) +
                  "\n            "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "media-gallery-navigation__item headline-2",
              attrs: {
                "active-class": "navigation-active",
                to: { name: _vm.ROUTES.COLLECTION },
              },
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("mediaGallery.navigation.collection.label")) +
                  "\n                "
              ),
              _vm.count > 0
                ? _c(
                    "span",
                    { staticClass: "media-gallery-navigation__item-count" },
                    [_vm._v(_vm._s(_vm.count))]
                  )
                : _vm._e(),
            ]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }